import { useState } from "react";
import MyTipTapEditor from "./MyTipTapEditor";

export default function TipTapWithJsonPreview() {
  const [html, setHtml] = useState("<p>Start writing…</p>");
  const [json, setJson] = useState<any>(null);

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">
        TipTap Editor → ProseMirror JSON
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* LEFT: EDITOR */}
        <div>
          <h2 className="font-medium mb-2">Editor</h2>

          <MyTipTapEditor
            value={html}
            onSave={(safeHtml, jsonData) => {
              setHtml(safeHtml);
              setJson(jsonData);
            }}
          />
        </div>

        {/* RIGHT: JSON PREVIEW */}
        <div>
          <h2 className="font-medium mb-2">ProseMirror JSON</h2>

          <pre className="bg-gray-100 border rounded-lg p-4 text-xs overflow-auto max-h-[500px]">
            {json
              ? JSON.stringify(json, null, 2)
              : "Edit content to see JSON output"}
          </pre>
        </div>
      </div>
    </div>
  );
}